import React from 'react';
import { useQuery } from '@apollo/client';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { GetCloseReasonsResponse, CloseReasonConfiguration as CloseReason, bpfAPI } from 'modules/stages';
import { useParams } from 'react-router-dom';

export const CloseReasonConfiguration = () => {
  const { id } = useParams<{ id: string }>();

  const { loading, error, data } = useQuery<GetCloseReasonsResponse, { id: string }>(bpfAPI.fetchCloseReasons, {
    variables: { id },
  });

  return (
    <PageContainer title="BPF Close reasons" loading={loading} error={error}>
      <CloseReason flowId={id} reasons={data ?? null} />
    </PageContainer>
  );
};
